import {createContext} from 'react'
import {ReturnType} from './types/return-type'

export const ToggleContext = createContext<ReturnType | null>(null)
